import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup'; // Add this import
import Dashboard from './components/Dashboard';
import Vehicles from './components/vehicles/Vehicles';
import Trips from './components/trips/Trips';
import ExcelUpload from './components/excel/ExcelUpload';
import Reports from './components/reports/Reports';
import Settings from './components/settings/Settings';
import Navbar from './components/layout/Navbar';
import Sidebar from './components/layout/Sidebar';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';
import Plants from './components/plants/Plants';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/auth.php', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ action: 'validate' })
        });
        
        const data = await response.json();
        if (data.valid) {
          setIsAuthenticated(true);
          setUser(data.user);
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
      }
    }
    setLoading(false);
  };

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading Vehicle Tracking System...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {isAuthenticated && (
          <>
            <Navbar user={user} onLogout={handleLogout} />
            <Sidebar user={user} />
          </>
        )}
        
        <main className={isAuthenticated ? 'main-content' : ''}>
          <Routes>
            <Route path="/login" element={
              isAuthenticated ? <Navigate to="/dashboard" /> : 
              <Login onLogin={handleLogin} />
            } />
            
            <Route path="/signup" element={
              isAuthenticated ? <Navigate to="/dashboard" /> : 
              <Signup onLogin={handleLogin} />
            } />
            
            <Route path="/" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Navigate to="/dashboard" />
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Dashboard user={user} />
              </ProtectedRoute>
            } />
            
            <Route path="/vehicles" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Vehicles user={user} />
              </ProtectedRoute>
            } />
            <Route path="/plants" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Plants user={user} />
              </ProtectedRoute>
            } />
            
            <Route path="/trips" element={
              <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['admin', 'operator']}>
                <Trips user={user} />
              </ProtectedRoute>
            } />
            
            <Route path="/excel-upload" element={
              <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['admin', 'operator']}>
                <ExcelUpload user={user} />
              </ProtectedRoute>
            } />
            
            <Route path="/reports" element={
              <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['admin']}>
                <Reports user={user} />
              </ProtectedRoute>
            } />
            
            <Route path="/settings" element={
              <ProtectedRoute isAuthenticated={isAuthenticated} allowedRoles={['admin']}>
                <Settings user={user} />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;